import { render, staticRenderFns } from "./TmhJourney.vue?vue&type=template&id=5af97c8c"
import script from "./TmhJourney.vue?vue&type=script&lang=js"
export * from "./TmhJourney.vue?vue&type=script&lang=js"
import style0 from "./TmhJourney.vue?vue&type=style&index=0&id=5af97c8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports